import React from 'react'

export default function About() {
  return (
    <>
    <section id='about' className='mx-auto items-center justify-center overflow-hidden pt-5 scroll-smooth duration-500 md:mt-32 text-[#e0e0e0] max-w-screen-xl md:pt-20 md:px-10 px-5'>
        <div className='mx-auto justify-center md:py-20 pb-14'>
            <div className='justify-center mx-auto items-center'>
                <p className='block md:hidden lg:hidden uppercase text-xs font-semibold text-[#000]'>
                    Cyber Security Solutions
                </p>
                <p className='uppercase font-semibold text-[#D8BB6C] pt-10 text-xs'>
                    WHAT WE DO
                </p>
                <h1 className='md:text-4xl text-2xl mx-auto md:pt-10 pt-5 text-[#000]'>
                    Securing Your Digital Frontier
                </h1>
            </div>
            <div className='mx-auto md:pt-8 pt-3 text-[#757575]'>
                <div className='tracking-wide justify-center'>
                    <p className='md:text-base text-sm'>
                        In an era where digital threats are evolving at an unprecedented pace, Elite Crown Diamond offers robust cybersecurity solutions tailored to protect our portfolio companies and their valuable assets. We are committed to fortifying the digital defenses of businesses in the fintech, health tech, and logistics sectors.
                    </p>
                </div>
            </div>
        </div>
            {/* <div className='justify-center w-full mx-auto pb-20 px-5 text-[#fff]'>
                <div className='md:flex grid grid-cols-3 md:gap-x-16 mx-auto justify-center text-center'>
                    <div className='md:py-10 md:max-w-sm py-3'>
                        <img className='mx-auto md:w-16 w-12' src='./Icons/Security/icons8-artificial-intelligence-100.png' alt='logo'/>
                        <h1 className='md:pt-10 pt-5 font-semibold md:text-base text-xs'>
                            AI
                        </h1>
                    </div>
                    <div className='md:py-10 md:max-w-sm py-3'>
                        <img className='mx-auto md:w-16 w-12' src='./Icons/Security/icons8-metaverse-100.png' alt='logo'/>
                        <h1 className='md:pt-10 pt-5 font-semibold md:text-base text-xs'>
                            Emerging Technology
                        </h1>
                    </div>
                    <div className='md:py-10 md:max-w-sm py-3'>
                        <img className='mx-auto md:w-16 w-12' src='./Icons/Security/icons8-5g-100.png' alt='logo'/>
                        <h1 className='md:pt-10 pt-5 font-semibold md:text-base text-xs'>
                            Integrating 5G
                        </h1>
                    </div>
                    <div className='md:py-10 md:max-w-sm py-3'>
                        <img className='mx-auto md:w-16 w-12' src='./Icons/Security/icons8-penetration-testing-100.png' alt='logo'/>
                        <h1 className='md:pt-10 pt-5 font-semibold md:text-base text-xs'>
                            Penetration Testing
                        </h1>
                    </div>
                    <div className='md:py-10 md:max-w-sm py-3'>
                        <img className='mx-auto md:w-16 w-12' src='./Icons/Security/icons8-internet-of-things-100.png' alt='logo'/>
                        <h1 className='md:pt-10 pt-5 font-semibold md:text-base text-xs'>
                            IOT
                        </h1>
                    </div>
                    <div className='md:py-10 md:max-w-sm py-3'>
                        <img className='mx-auto md:w-16 w-12' src='./Icons/Security/icons8-application-form-100.png' alt='logo'/>
                        <h1 className='md:pt-10 pt-5 font-semibold md:text-base text-xs'>
                            Threat Intelligence
                        </h1>
                    </div>
                </div>
            </div>
            <div className='justify-center mx-auto w-full bg-[#101010] px-5'>
                <div className='text-[#aaa] max-w-screen-xl mx-auto justify-center md:py-20 py-10 text-center md:text-xl text-xs'>
                    <p>
                        In a world where cyber threats are ever-advancing, our dedication to integrating AI and cutting-edge technologies into our solutions sets us apart. 
                        Great Winchester is your trusted partner, ensuring that your digital assets remain protected, no matter how the cybersecurity landscape evolves.
                    </p>
                </div>
            </div> */}
    </section>
    </>
  )
}